import PropTypes from 'prop-types'
import Link from 'next/link'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { supported } from 'utils/mapbox'
import * as utils from 'utils/min'
import typography from 'styles/typography.module.css'
import buttons from 'components/button/Button.module.css'

Home.propTypes = {
    href: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
}

export function Home({ href = '/', children, className, ...props }) {
    className = clsx(typography.Back, className)

    return (
        <Link href={href} className={className} {...props}>
            {children || <FormattedMessage description="Component links/Home" defaultMessage="Back to home" />}
        </Link>
    )
}

MountainInformationNetwork.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.element,
}

export function MountainInformationNetwork({ id, children, ...props }) {
    const href = mountainInformationNetwork(id)

    return (
        <Link href={href} {...props}>
            {children}
        </Link>
    )
}

export function mountainInformationNetwork(id) {
    return supported() ? `/map?panel=mountain-information-network-submissions/${id}` : utils.submission(id)
}

Forecast.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.element,
}

export function Forecast({ id, children, ...props }) {
    return (
        <Link href={forecast(id)} {...props}>
            {children}
        </Link>
    )
}

export function forecast(id) {
    const root = supported() ? '/map' : ''

    return root + `/forecasts/${id}`
}

export function Button({ children, large, href, ...props }) {
    const className = clsx(buttons.Primary, {
        [buttons.Large]: large,
    })

    return (
        <Link href={href} {...props} className={className}>
            {children}
        </Link>
    )
}
